import type { FetchArgs } from '@reduxjs/toolkit/query/react';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { authReducer } from 'src/redux/slices/authReducer.slice';
import type { RootState } from '../redux/store';

const refreshToken = async (dispatch: any, refresh_token: string) => {
  const response = await fetch(`${import.meta.env.VITE_API_BASE_URL}/token/refresh/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ refresh: refresh_token }),
  });

  if (!response.ok) {
    dispatch(authReducer.actions.logout());
    throw new Error('Failed to refresh token');
  }

  const data = await response.json();

  return data.access;
};

const baseQuery = fetchBaseQuery({
  baseUrl: `${import.meta.env.VITE_API_BASE_URL}`,
  prepareHeaders: (headers, { getState }) => {
    const state = getState() as RootState;
    headers.set('Authorization', `Bearer ${state.authReducer.token}`);
    return headers;
  },
});

export const baseQueryWithReauth: any = async (args: FetchArgs, store: any, extraOptions: any) => {
  let result = await baseQuery(args, store, extraOptions);

  const authState = (store.getState() as RootState).authReducer;

  if (result.error && result.error.status === 401) {
    if (!authState.token || !authState.refresh_token) return result;

    const newAccessToken = await refreshToken(store.dispatch, authState.refresh_token);

    if (newAccessToken) {
      store.dispatch(authReducer.actions.setAccessToken(newAccessToken));
      result = await baseQuery(args, store, extraOptions);
    } else {
      store.dispatch.authReducer.action.logout();
    }
  }
  return result;
};

export const api = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: () => ({}),
  tagTypes: ['MaintenanceTypes', 'AllGroups', 'Group', 'Routes'],
});
